import { Component, OnInit, Input } from '@angular/core';
import { VendorResponseTypes, CriminalSearchTypes, SearchVendors, SearchRecord } from 'src/app/models/searchPackage';

@Component({
  selector: 'app-search-builder',
  templateUrl: './search-builder.component.html',
  styleUrls: ['./search-builder.component.less']
})
export class SearchBuilderComponent implements OnInit {
  searchTypes : VendorResponseTypes;
  searchVendors : SearchVendors;
  SearchVendors : typeof SearchVendors = SearchVendors;
  criminalQualifier : CriminalSearchTypes;
  state : string;
  county : string;
  evictionSearchTypes : Array<string> = new Array<string>();
  vendors : Array<string> = new Array<string>();
  @Input() search : SearchRecord;
  constructor() { 
    this.evictionSearchTypes.push("National");
    this.evictionSearchTypes.push("State");
    
    this.vendors.push("Tazworks");
    this.vendors.push("Tracers");
  }

  ngOnInit() {
    this.search.searchMeta = {}
  }

  setSearchVendor(tp :string){
    this.search.vendor = SearchVendors[tp];
    console.log(this.search)
  }


  public get criminalSearchQualifiers() : Array<string> {
    const keys = Object.keys(CriminalSearchTypes);
    return keys.slice(keys.length/2)
  }

  setSearchType(tp :string){
    this.criminalQualifier = CriminalSearchTypes[tp];
    this.search.searchMeta.searchDepth = this.criminalQualifier;
    console.log(this.search)
  }


  
}
